import TaskQueue from "./TaskQueue";
import _ from "underscore";
const getQueue = _.memoize((campaignId) => {
    return new TaskQueue();
});
export default {
    getQueue,
};
